import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useWritePromptUpdate = () => {
  const createWritePromptUpdateRequest = useCallback((payload) => {
    const { promptId, text } = payload;

    const body = {
      text,
    };

    const requestUrl = `${MONOLITH_ORIGIN}/api/v2/prompt/${promptId}/`;

    return new Request(requestUrl, {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createWritePromptUpdateRequest);
};

export default useWritePromptUpdate;
